import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Menu, ArrowRight } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Logo } from '@/components/Logo';
import { useQuote } from '@/context/QuoteContext';

const NAV = [
  { to: '/', label: 'Accueil' },
  { to: '/boutique', label: 'Boutique' },
  { to: '/a-propos', label: 'L’entreprise' },
  { to: '/contact', label: 'Contact' },
];

export default function SiteHeader() {
  const [openSheet, setOpenSheet] = useState(false);
  const navigate = useNavigate();
  const { openQuote } = useQuote();

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-border" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-6">
        <Link to="/" data-testid="logo-link" aria-label="Accueil">
          <Logo size="md" />
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `text-sm font-medium tracking-[0.01em] transition-colors ${isActive ? 'text-[hsl(186_55%_38%)]' : 'text-foreground hover:text-[hsl(186_55%_38%)]'}`}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
              end={item.to === '/'}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button
            onClick={() => openQuote()}
            className="hidden sm:inline-flex bg-primary hover:bg-primary/90 text-primary-foreground rounded-xl"
            data-testid="nav-request-quote-button"
          >
            Demander un devis
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>

          <Sheet open={openSheet} onOpenChange={setOpenSheet}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="md:hidden" data-testid="mobile-menu-button" aria-label="Menu">
                <Menu className="w-5 h-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-80">
              <SheetHeader>
                <SheetTitle>
                  <Logo size="sm" />
                </SheetTitle>
              </SheetHeader>
              <div className="mt-6 flex flex-col gap-1">
                {NAV.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    onClick={() => setOpenSheet(false)}
                    className={({ isActive }) => `px-3 py-3 rounded-lg text-sm font-medium ${isActive ? 'bg-secondary text-foreground' : 'text-foreground hover:bg-secondary'}`}
                    end={item.to === '/'}
                  >
                    {item.label}
                  </NavLink>
                ))}
                <Button
                  className="mt-4 rounded-xl"
                  onClick={() => { setOpenSheet(false); openQuote(); }}
                  data-testid="mobile-request-quote-button"
                >
                  Demander un devis
                </Button>
                <button
                  onClick={() => { setOpenSheet(false); navigate('/admin/login'); }}
                  className="mt-3 text-xs text-muted-foreground self-start hover:text-foreground"
                >
                  Espace admin
                </button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
